import { isNil } from "lodash";

type DefinedFaultTask = {
    duration: number;
    endTime: number;
    executedEndTime: number;
    executedStartTime: number;
    executionRequirement: {
        timeOffset: number;
    };
    executionTrigger: "EventBase" | "TimeBase" | string;
    executionType: "Defined" | string;
    faultDetails: any | null;
    faultId: string;
    faultName: string;
    faultRefId: string;
    faultSystem: string;
    faultTaskId: string;
    faultType: string;
    message: string;
    startTime: number;
    status: "SCHEDULED" | "FAILED" | "NOT_POSSIBLE" | string;
}

export function groupFaultsByOverlap(faults: DefinedFaultTask[]) {
    if (!faults.length) return [];

    const filterFaults = faults?.filter(fault => fault?.status !== 'CANCELLED')
    const sorted = filterFaults?.sort((a, b) => a.startTime - b.startTime);

    const groups: DefinedFaultTask[][] = [];
    let currentGroup: DefinedFaultTask[] = [sorted[0]];
    let currentEnd = sorted[0].startTime;

    for (let i = 1; i < sorted.length; i++) {
        const f = sorted[i];

        // Overlap check
        if (f.startTime <= currentEnd) {
            // same group
            currentGroup.push(f);
            currentEnd = Math.max(currentEnd, f.startTime);
        } else {
            // new group
            groups.push(currentGroup);
            currentGroup = [f];
            currentEnd = f.startTime;
        }
    }
    groups.push(currentGroup);
    return groups;
}


export const formatExecDurationValue = (value: unknown): string | null => {
    if (isNil(value)) return null;
    const numeric = typeof value === 'number' ? value : Number(value);
    if (Number.isFinite(numeric)) {
        if (numeric === 0) return null;
        return `${numeric}min`;
    }
    return String(value);
};